import { render } from "./HelloI18n.vue?vue&type=template&id=36965acf"
import script from "./HelloI18n.vue?vue&type=script&lang=js"
export * from "./HelloI18n.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__